import { render } from "./Links1.vue?vue&type=template&id=8680549a"
import script from "./Links1.vue?vue&type=script&lang=js"
export * from "./Links1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__